import classNames from 'classnames';
import { DetailedHTMLProps, LabelHTMLAttributes } from 'react';

interface RadioLabelProps extends DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
  disabled?: boolean;
}

export default function RadioLabel({
  className,
  disabled,
  children,
  ...props
}: RadioLabelProps) {
  return (
    <label
      className={classNames(
        '[&_input]:mt-[5px] flex space-x-2',
        disabled ? 'text-slate-400' : 'cursor-pointer',
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
}
